export default __webpack_public_path__ + "static/media/Slow.3ddb3df5.svg";